import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Players } from 'src/app/shared/models/players';
import { PlayerScores } from 'src/app/shared/models/player-scores';
import { FinishMatchService } from 'src/app/shared/services/finish-match.service';


@Component({
  selector: 'app-results-dialog',
  templateUrl: './results-dialog.component.html',
  styleUrls: ['./results-dialog.component.css']
})
export class ResultsDialogComponent implements OnInit {
  playersFinal: Players;
  message: string;
  par: number;
  courseName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public finishMatchService: FinishMatchService,
  ) {
    this.playersFinal = data.players;
    this.par = data.par;
    this.courseName = data.courseName;
  }

  ngOnInit() {

    let totalScore: number;
    console.log(this.playersFinal);
    this.playersFinal.playerScores.forEach((p: PlayerScores) => {
      totalScore = p.scores.slice(0, 18).reduce((a, b) => a + b.score, 0);
      if ((totalScore - this.par) < 0) {
        p.message = `Your score is ${totalScore - this.par} under par, great job!`;
      }
      if ((totalScore - this.par) >= 0 && (totalScore - this.par) < 5) {
        p.message = `Your score is ${totalScore - this.par} over par, better luck next time!`;
      }
      if ((totalScore - this.par) >= 5) {
        p.message = `Your score is ${totalScore - this.par} over par, you may need some more practice!`;
      }
    });
  }

  onSubmit() {
    this.playersFinal.playerScores.forEach((p: PlayerScores) => {
      this.finishMatchService.finishMatch(p, this.courseName);
    });
  }
}
